exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".changeLogVersion>h2[data-v-7b45040f]{margin-top:20px;margin-bottom:0;padding:0}.changeLogVersion .date[data-v-7b45040f],.changeLogVersion .empty[data-v-7b45040f]{color:#999;text-align:center;margin-bottom:10px;font-style:italic}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7b45040f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ChangeLogVersion.vue
// module id = 156
// module chunks = 0